import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DeveloperHomeIcon = ({
  title
}) => {
  return /*#__PURE__*/_jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-test-id": "vertical-nav-icon__developer-home",
    children: [title ? /*#__PURE__*/_jsx("title", {
      children: title
    }) : null, /*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_114_146)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M14.9836 8.04666C15.277 8.29819 15.4806 8.28022 15.7861 8.00474C16.0735 7.73525 16.0975 7.57355 15.6962 7.20226L12.4743 4.28576V1.80645C12.4713 1.77097 12.4546 1.73806 12.4278 1.71461C12.401 1.69116 12.3662 1.679 12.3306 1.68068H10.8214C10.7859 1.679 10.751 1.69116 10.7242 1.71461C10.6974 1.73806 10.6808 1.77097 10.6777 1.80645V2.62091L8.49184 0.65063C8.38769 0.553814 8.25076 0.5 8.10856 0.5C7.96636 0.5 7.82943 0.553814 7.72528 0.65063L0.275355 7.17231C-0.0779776 7.50169 -0.0839663 7.69333 0.215468 7.9748C0.263233 8.03696 0.323713 8.08821 0.392867 8.12512C0.462022 8.16204 0.538258 8.18378 0.616483 8.18888C0.694709 8.19398 0.773122 8.18233 0.846486 8.15471C0.919849 8.12708 0.986473 8.08412 1.04191 8.02869C1.28744 7.83107 6.62935 3.14791 8.10856 1.84238C9.50393 3.10599 14.8219 7.90892 14.9836 8.04666Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.9355 15.1792V8.14248L8.30018 3.12396C8.24595 3.07757 8.17692 3.05207 8.10555 3.05207C8.03418 3.05207 7.96516 3.07757 7.91092 3.12396L2.25161 8.14248V15.1792H6.31793V10.9871C6.31712 10.9366 6.32648 10.8863 6.34545 10.8395C6.36443 10.7926 6.39263 10.75 6.42838 10.7143C6.46414 10.6785 6.50671 10.6503 6.55358 10.6314C6.60044 10.6124 6.65065 10.603 6.7012 10.6038H9.48594C9.5365 10.603 9.5867 10.6124 9.63357 10.6314C9.68044 10.6503 9.72301 10.6785 9.75876 10.7143C9.79452 10.75 9.82272 10.7926 9.84169 10.8395C9.86067 10.8863 9.87003 10.9366 9.86922 10.9871V15.1792H13.9355Z"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_114_146",
        children: /*#__PURE__*/_jsx("rect", {
          width: "16",
          height: "16"
        })
      })
    })]
  });
};